// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2AYU8","itemTitle":"ClientEmergencyInfo_itemTitle__YIg3b","itemText":"ClientEmergencyInfo_itemText__1SSwJ"};